import { theme } from '@arnold/common';
import styled from '@emotion/styled/macro';

export const Button = styled.button`
  background-color: ${theme.colors.actionPrimary.default};
  padding: ${theme.spacing.c} ${theme.spacing.g};
  font-weight: 500;
  color: #fff;
  border-radius: 23px;
  border: none;
  cursor: pointer;
  outline: 0;

  :hover,
  :focus {
    background-color: #04a5d8;
    border-color: #04a5d8;
    outline: 0;
  }
  :active {
    background-color: ${theme.colors.actionPrimary.focused};
    border-color: ${theme.colors.actionPrimary.focused};
  }
`;
